import { APARTMENT_GROUP } from '../../../utils/Constants';

export const floors = [
  { index: 1, name: APARTMENT_GROUP.GROUND, title: 'Prizemlje' },
  { index: 2, name: APARTMENT_GROUP.FLOOR_ONE, title: 'Kat 1' },
  { index: 3, name: APARTMENT_GROUP.FLOOR_TWO, title: 'Kat 2' },
  { index: 4, name: APARTMENT_GROUP.FLOOR_THREE, title: 'Kat 3' },
  { index: 5, name: APARTMENT_GROUP.FLOOR_FOUR, title: 'Kat 4' },
  { index: 6, name: APARTMENT_GROUP.SUPERSTRUCTURE, title: 'Nadgrađe' },
];
